<template>
  <section class="reports-done">
    <header>
      <div class="title">
        <h1>{{ $tc('reports.doneTitle', isMultiple ? 2 : 1) }}</h1>
        <p>{{ $tc('reports.doneSubtitle', isMultiple ? 2 : 1) }} <a href="#">{{ $tc('reports.doneDownloadAgain', isMultiple ? 2 : 1) }}</a>.</p>
      </div>
    </header>
    <div class="buttons">
      <button @click.prevent="$emit('to', 'select')">{{ $t('buttons.createMore') }}</button>
      <router-link to="/" class="alt-btn" tag="button">{{ $t('buttons.done') }}</router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'reports-done',
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.reports-done {
  text-align: center;

  button + button {
    margin-left: 25px;
  }
}
</style>
